module.exports = __webpack_public_path__ + "static/media/NotoSansTC-Regular.a136a9b3.ttf";